import * as React from "react";
import { connect, type ConnectedProps } from "react-redux";
import TetherComponent from "react-tether";
import { type RootState } from "../../Reducers/ShopfrontReducers";

function mapStateToProps(state: RootState): {
    loggedIn: boolean;
} {
    return {
        loggedIn: !!state.user.id,
    };
}

const connector = connect(mapStateToProps);

interface Props extends ConnectedProps<typeof connector> {
    target: (ref: React.RefObject<Element>) => React.ReactNode;
    element?: (ref: React.RefObject<Element>) => React.ReactNode;
    tetherProps?: Record<string, any>;
    pin?: boolean;
}

export class Tether extends React.Component<Props> {
    public render(): React.ReactNode {
        let pin = true;

        if(typeof this.props.pin === "boolean") {
            pin = this.props.pin;
        }

        return (
            <TetherComponent
                attachment="top left"
                targetAttachment="bottom left"
                constraints={[{
                    to        : "window",
                    attachment: "together",
                    pin,
                }]}
                {...this.props.tetherProps}
                renderTarget={this.props.target}
                renderElement={ref => this.props.loggedIn && this.props.element && this.props.element(ref)}
            />
        );
    }
}

export default connector(Tether);
